export enum ClientDirectoryBucketEnum {
  ClientRequest = 'client-request',
  OnboardingProcess = 'onboarding-process',
  AccountVerification = 'account-verification',
}
